(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .controller('PatrimoineSiteController', PatrimoineSiteController);


    function PatrimoineSiteController($scope, patrimoine, swifOpenbaseCompanyService, swif, swifRouteService, swifCartoLeafletService, openbase){
        'ngInject';
        var service = patrimoine.referentiel;
        console.log('init PatrimoineSiteController');
        $scope.moduleCarto = swif.module.modules.opengst_carto;
        $scope.showLeaflet = false;
        $scope.route = swifRouteService;
        $scope.choices = {};
        $scope.proxy = {};
        $scope.filters = service.getFilters();
        $scope.tab = {
            vente: false,
            acquisition: false
        };

        $scope.getCustomFieldsTemplate = openbase.customfields.getTemplateFromCategory;
        // #3069 temporary boolean for customFields
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;

        if ($scope.model.osm_zoom) {
            $scope.model._osm_zoom = $scope.model.osm_zoom;
        }
        $scope.initCarto = function () {
            $scope.route.check({resources: ['leaflet']}).then(function () {
                $scope.showLeaflet = true;
            });
        };
        $scope.onMapInitialized = function (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                map.setZoom($scope.model.osm_zoom);
            }
        };
        $scope.onTabSelected = function (id) {
            $scope.tab[id] = true;
        };
        $scope.computeSurface = function () {
            $scope.model.surface = $scope.model.width * $scope.model.length;
        };

        $scope.choices = {states: openbase.equipment.getStatesConfig()};
        $scope.STATES = {};
        _.forEach($scope.choices.states, function (item) {
            $scope.STATES[item.id] = item.name;
        });

        // site.state undefined for creation
        if (!$scope.model.state){
            $scope.model.state = [false, $scope.STATES[false]];
        }

        $scope.$watch('model.state', function (newV) {
            if (_.isString(newV)) {
                $scope.model.state = [newV, $scope.STATES[newV]];
            }
        });

        // There is no "swifChange" function attribute on selectMultiple widget.
        // Had to watch the new value..
        $scope.$watch('model.type_ids', function (newV, oldV) {
            console.log("model site", $scope.model.type_ids);
            let type_id = _.difference(newV,oldV);
            if (type_id) {
                swif.data.get('site_category', type_id[0]).then(category => {
                    $scope.model.custom_fields = _.union($scope.model.custom_fields, category.custom_fields)
                });
            }
        });

        $scope.$watch('model.cadastre_commune', watchCadastreCommune);
        $scope.$watch('model._osm_zoom', setZoom);
        if (!$scope.model.id){
            swifOpenbaseCompanyService.getCompany().then(function(company) {
                $scope.model.city = company.city;
                $scope.model.zip = company.zip;
            });
        }
        function watchCadastreCommune(newV) {
            if (newV) {
                $scope.filters = service.getFilters();
            }
        }
        function setZoom (zoom) {
            if (zoom === undefined) {
                $scope.model.osm_zoom = false;
            } else {
                $scope.model.osm_zoom = zoom;
                if ($scope.map) {
                    $scope.map.setZoom(zoom);
                }
            }
        }

        $scope.siteCodeAlreadyExist = false;
        // Checks site_code unicity
        $scope.$watch('model.site_code', function (newRef, oldRef) {
            if (!newRef || newRef == oldRef) {
                return;
            }

            var params = {
                fields: ['id'],
                domain: [
                    ['site_code', '=', newRef]
                ]
            };

            // Exclude current object id
            if ($scope.model._type == 'patrimoine_site' && $scope.model.id) {
                params.domain.push(['id', '!=', $scope.model.id]);
            }

            // Checks for matched site according to site_code
            // Display panel-site component if found
            swif.data.searchRead('site', params).then(function (matchedSite_codes) {
                if (matchedSite_codes.ids.length > 0) {
                    $scope.siteCodeAlreadyExist = true;
                    $scope.matchedSite = matchedSite_codes.ids[0]
                } else {
                    delete $scope.matchedSite;
                    $scope.siteCodeAlreadyExist = false;
                }

                $scope.form['model.site_code'].$setValidity(
                    'default',                          // default don't exist: just highlight the field in red without any message
                    matchedSite_codes.ids.length === 0  // if there is no matched site found
                );
            });
        });
    }

})();
